import './styles.scss';

import React from 'react';

import { withDefaults } from '../../../../utils/object';

const DEFAULTS = { name: '', onStepForward: () => {}, onStepBack: () => {}, skipIf: null };

const Step = ({ children, ...props }: any) => {
  const propsWithDefaults = withDefaults(DEFAULTS, props);
  return <React.Fragment>{typeof children === 'function' ? children(propsWithDefaults) : children}</React.Fragment>;
};

Step.displayName = 'Step';

export default Step;
